import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";
import { RunEventDistance, runEventDistanceFromJson, RunEventDistancePaginationFilterRequest, UpsertRunEventDistance } from '@/models/run-event-distance.model';
import { jsDateToZone } from '@/utils/date-time';

export const getPagedRunEventDistances = async (input: RunEventDistancePaginationFilterRequest): Promise<PagedResponseModel<RunEventDistance>> => {
  return await getReq(createUrl("a/RunEvent/Distance/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => runEventDistanceFromJson(itm))
  }));
};

export const getRunEventDistancesLookup = async (keyword?: string, runEventId?: number, page?: number): Promise<PaginatedSelectModel> => {
  const model: RunEventDistancePaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: keyword,
    isAscending: false,
    runEventId: runEventId
  };
  return await getPagedRunEventDistances(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: `Start: ${jsDateToZone(itm.startDate, itm.city?.ianaTimeZoneId)}`
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })
  );
};

export const getRunEventDistance = async (id: number): Promise<BaseResponseModel<RunEventDistance>> => {
  return await getReq(createUrl(`a/RunEvent/Distance/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: runEventDistanceFromJson(res.data.result)
  }));
};

export const upsertRunEventDistance = async (input: UpsertRunEventDistance): Promise<BaseResponseModel<RunEventDistance>> => {
  return await postReq(createUrl("a/RunEvent/Distance/Upsert"),
    input
  ).then((res: any) => ({
      ...res.data,
      result: runEventDistanceFromJson(res.data.result)
    }));
};